'use client';
import React from 'react'
import { useEffect } from 'react';

export default function ScriptEmbeded() {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = "https://form.jotform.com/jsform/92806909668171";
        script.type = 'text/javascript';
        script.async = true;
    
        // Select the element where you want to insert the script
        const container = document.getElementById('form-container');
        
        if (container) {
          // Append the script to the selected container
          container.appendChild(script);
        }
    
        return () => {
          if (container) {
            container.removeChild(script); // Clean up the script when component unmounts
          }
        };
      }, []); 
  return (
    <div id="form-container">
      
    </div>
  )
}